import { render, staticRenderFns } from "./ObjectiveSectionResult.vue?vue&type=template&id=70cec3aa&scoped=true&"
import script from "./ObjectiveSectionResult.vue?vue&type=script&lang=js&"
export * from "./ObjectiveSectionResult.vue?vue&type=script&lang=js&"
import style0 from "./ObjectiveSectionResult.vue?vue&type=style&index=0&id=70cec3aa&prod&lang=scss&scoped=true&"
import style1 from "./ObjectiveSectionResult.vue?vue&type=style&index=1&id=70cec3aa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70cec3aa",
  null
  
)

export default component.exports